"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _constructedForm = _interopRequireDefault(require("./constructed-form.props/constructed-form.defaultProps"));
var _constructedForm2 = _interopRequireDefault(require("./constructed-form.props/constructed-form.propTypes"));
var _p; // import DataUtils from "@mmc-tools/mmc-data-utilities";
// import styles from "../styles/constructed-form.css";
/**
 * ## MultiSelect - component
 *
 * Some really cool piece of description goes here.
 */
// We use the same default props for data and defaultData
// This keeps our PropTypes and DefaultProps objects nice and clean and non repeating
// const dataUtils = new DataUtils();
// const {
//   shouldUseDataOrDefaultProps,
//   getComponentDataByResourceType,
//   handleNestedProp
// } = dataUtils;
var MultiSelect = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(MultiSelect, _React$Component);
  function MultiSelect() {
    return _React$Component.apply(this, arguments) || this;
  }
  // All components need a resourceType in order for AEM to be aware of its existance
  MultiSelect.resourceType = function resourceType() {
    return 'ChoiceType_1_0_0';
  };
  var _proto = MultiSelect.prototype;
  _proto.render = function render() {
    // const { data } = this.props;
    return _p || (_p = /*#__PURE__*/_react["default"].createElement("p", null, "Some form MultiSelect"));
  };
  return MultiSelect;
}(_react["default"].Component);
exports["default"] = MultiSelect;
MultiSelect.displayName = 'MultiSelect';
MultiSelect.defaultProps = {
  data: _constructedForm["default"].formComponents[9],
  // eslint-disable-line
  theme: {}
};